import React from "react";
import {
  Checkbox,
  FlatButton,
  MenuItem,
  Paper,
  RaisedButton,
  SelectField,
  TextField,
  Toggle
} from "material-ui";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import { gql, graphql as apollo } from "react-apollo";
import { commitMutation, graphql } from "react-relay";
import { StyleSheet, css } from "aphrodite";

import environment from "../../relay/environment";
import DateRange from "../DateRangeComponent";
import OurismanTravelTheme from "../../ourismanTravelTheme";

const EditTripQuery = gql`
  query TripDetailsQuery {
    allUsers(groups_Name: "Team") {
      edges {
        node {
          id
          firstName
          username
        }
      }
    }
    tripCategories {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

@connect()
@apollo(EditTripQuery)
class EditTrip extends React.Component {
  static propTypes = {
    trip: PropTypes.shape({
      owner: PropTypes.shape({ id: PropTypes.string })
    }).isRequired,
    handleSave: PropTypes.func.isRequired,
    data: PropTypes.shape().isRequired
  };

  constructor(props) {
    super(props);

    const {
      trip: {
        owner,
        inbox,
        category,
        destination,
        specificDates,
        startDate,
        endDate,
        timeFrame = "",
        needsVetting,
        segments,
        prospect
      }
    } = this.props;

    let segmentStartDate = null;
    let segmentEndDate = null;
    const validSegments = segments.filter(
      segment => segment.cancelled === false
    );
    if (validSegments.length > 0) {
      const segmentDates = validSegments
        .map(segment => [moment(segment.startDate), moment(segment.endDate)])
        .reduce((first, second) => {
          const start =
            (first[0] && second[0] && moment.min(first[0], second[0])) ||
            first[0] ||
            second[0] ||
            null;
          const end =
            (first[1] && second[1] && moment.max(first[1], second[1])) ||
            first[1] ||
            second[1] ||
            null;

          return [start, end];
        });
      segmentStartDate = segmentDates[0];
      segmentEndDate = segmentDates[1];
    }

    this.state = {
      owner,
      inbox,
      categoryId: category.id,
      categoryName: category.name,
      destination,
      specificDates,
      startDate,
      endDate,
      timeFrame,
      ownerId: owner.id,
      needsVetting,
      prospect,
      segmentStartDate,
      segmentEndDate,
      validDates: true
    };
  }

  close = () => {
    this.props.handleSave();
  };

  fitToSegments = () => {
    const {
      trip: { id: tripId }
    } = this.props;
    const {
      inbox,
      ownerId,
      categoryId,
      destination,
      specificDates,
      timeFrame,
      needsVetting,
      prospect
    } = this.state;
    let { segmentStartDate: startDate, segmentEndDate: endDate } = this.state;

    if (moment.isMoment(startDate)) {
      startDate = startDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }
    if (moment.isMoment(endDate)) {
      endDate = endDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }

    commitMutation(environment, {
      mutation: graphql`
        mutation EditTrip_UpdateTrip_Mutation($input: UpdateTripInput!) {
          updateTrip(input: $input) {
            trip {
              inbox
              tripName
              ownerId
              ownerName
              owner {
                id
              }
              category {
                id
                name
              }
              destination
              specificDates
              timeFrame
              startDate
              endDate
              dateString
              needsVetting
              prospect
              welcomeHome
              tasks {
                taskType
                description
                completed
                voided
                history {
                  name
                  action
                  timestamp
                }
              }
            }
          }
        }
      `,
      variables: {
        input: {
          tripId,
          inbox,
          ownerId,
          categoryId,
          destination,
          specificDates,
          timeFrame,
          startDate,
          endDate,
          needsVetting,
          prospect
        }
      },
      onCompleted: () => this.close(),
      onError: err => alert(err)
    });
  };

  save = () => {
    const {
      trip: { id: tripId }
    } = this.props;
    const {
      inbox,
      ownerId,
      categoryId,
      destination,
      specificDates,
      timeFrame,
      needsVetting,
      prospect
    } = this.state;
    let { startDate, endDate } = this.state;

    if (moment.isMoment(startDate)) {
      startDate = startDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }
    if (moment.isMoment(endDate)) {
      endDate = endDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }

    commitMutation(environment, {
      mutation: graphql`
        mutation EditTrip_UpdateTrip_Mutation($input: UpdateTripInput!) {
          updateTrip(input: $input) {
            trip {
              inbox
              tripName
              ownerId
              ownerName
              owner {
                id
              }
              category {
                id
                name
              }
              destination
              specificDates
              timeFrame
              startDate
              endDate
              dateString
              needsVetting
              prospect
              welcomeHome
              tasks {
                taskType
                description
                completed
                voided
                history {
                  name
                  action
                  timestamp
                }
              }
            }
          }
        }
      `,
      variables: {
        input: {
          tripId,
          inbox,
          ownerId,
          categoryId,
          destination,
          specificDates,
          timeFrame,
          startDate,
          endDate,
          needsVetting,
          prospect
        }
      },
      onCompleted: () => this.close(),
      onError: err => alert(err)
    });
  };

  updateTextField = fieldName => e => {
    const {
      target: { value }
    } = e;
    const newState = this.state;
    newState[fieldName] = value;
    this.setState(newState);
  };

  toggleField = fieldName => e => {
    const {
      target: { checked }
    } = e;
    const stateUpdate = {};
    stateUpdate[fieldName] = checked;
    this.setState(stateUpdate);
  };

  selectInbox = (e, value) => {
    this.setState({ inbox: value });
  };

  updateSelect = name => (e, index, value) => {
    const newState = {};
    newState[name] = value;
    this.setState(newState);
  };

  updateTravelDates = e => {
    const { startDate, endDate } = e;
    const { segmentStartDate, segmentEndDate } = this.state;

    const validStart =
      startDate &&
      startDate.isValid() &&
      (segmentStartDate === null || startDate <= segmentStartDate);
    const validEnd =
      endDate &&
      endDate.isValid() &&
      (segmentEndDate === null || endDate >= segmentEndDate);
    const validDates = validStart && validEnd;

    this.setState({ startDate, endDate, validDates });
  };

  toggleNeedsVetting = (e, checked) => {
    this.setState({ needsVetting: checked });
  };

  toggleProspect = (e, checked) => {
    this.setState({ prospect: checked });
  };

  render() {
    const {
      inbox,
      categoryId,
      destination,
      specificDates,
      startDate,
      endDate,
      timeFrame,
      needsVetting,
      validDates,
      prospect,
      ownerId
    } = this.state;
    const {
      data,
      trip: { segments }
    } = this.props;

    let users = [];
    let categories = [];
    if (!data.loading) {
      users = data.allUsers.edges.map(({ node }) => node);
      categories = data.tripCategories.edges.map(({ node }) => node);
    }

    return (
      <Paper className={css(styles.detailsContainer)}>
        <h3>Admin</h3>
        <div className={css(styles.fieldsGroup)}>
          <SelectField
            className={css(styles.formField)}
            floatingLabelText="Inbox:"
            value={inbox}
            onChange={this.updateSelect("inbox")}
          >
            {["team@", "insidecircle@", "david@", "jessica@"].map(
              (option, index) => (
                <MenuItem key={index} value={option} primaryText={option} />
              )
            )}
          </SelectField>
          <SelectField
            className={css(styles.formField)}
            floatingLabelText="Assign trip to:"
            value={ownerId}
            onChange={this.updateSelect("ownerId")}
          >
            {users.map(({ id, firstName }) => (
              <MenuItem key={id} value={id} primaryText={firstName} />
            ))}
          </SelectField>
          <SelectField
            className={css(styles.formField)}
            floatingLabelText="Trip Category:"
            value={categoryId}
            onChange={this.updateSelect("categoryId")}
          >
            {categories.map(({ id, name }) => (
              <MenuItem key={id} value={id} primaryText={name} />
            ))}
          </SelectField>
          <Checkbox
            className={css(styles.formField)}
            checked={needsVetting}
            onCheck={this.toggleNeedsVetting}
            label="Needs Vetting"
          />
          <Checkbox
            className={css(styles.formField)}
            checked={prospect}
            onCheck={this.toggleProspect}
            label="Prospect"
          />
        </div>

        <h3>Trip Overview</h3>
        <div className={css(styles.fieldsGroup)}>
          <TextField
            floatingLabelText="Trip Name"
            value={destination}
            onChange={this.updateTextField("destination")}
            fullWidth
          />
          <div>
            {specificDates ? (
              <DateRange
                startValue={startDate}
                endValue={endDate}
                startLabel="Travel Start Date"
                endLabel="Travel End Date"
                onChange={this.updateTravelDates}
              />
            ) : (
              <TextField
                floatingLabelText="Timeframe"
                value={timeFrame}
                onChange={this.updateTextField("timeFrame")}
              />
            )}
            <Toggle
              className={css(styles.specificDates)}
              checked={specificDates}
              onClick={this.toggleField("specificDates")}
              label="Specific Dates"
              labelPosition="right"
            />
            <FlatButton
              label="Fit to segments"
              disabled={segments.length < 1}
              onTouchTap={this.fitToSegments}
            />
          </div>
        </div>

        {validDates ? null : (
          <div className={css(styles.errorMessage)}>
            <span>
              Specified dates are invalid or do not contain all segments.
            </span>
          </div>
        )}
        <div className={css(styles.formActions)}>
          <RaisedButton
            className={css(styles.formButton)}
            label="Cancel"
            secondary
            onTouchTap={this.close}
          />
          <RaisedButton
            className={css(styles.formButton)}
            label="Save"
            primary
            onTouchTap={this.save}
            disabled={!validDates}
          />
        </div>
      </Paper>
    );
  }
}

const styles = StyleSheet.create({
  formActions: {
    display: "flex",
    justifyContent: "flex-end"
  },
  errorMessage: {
    color: OurismanTravelTheme.palette.accent1Color,
    justify: "right",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end"
  },
  formButton: {
    marginRight: 15
  },
  fieldsGroup: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    flexWrap: "wrap",
    alignItems: "baseline",
    marginBottom: 15
  },
  specificDates: {
    marginTop: 15
  },
  detailsContainer: {
    padding: 15
  },
  checkboxes: {
    display: "flex"
  },
  formField: {
    flexShrink: 1,
    flexBasis: "30%"
  }
});

export default EditTrip;



// WEBPACK FOOTER //
// /src/components/Trips/EditTrip.js